function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicrosoftTeamsRemoveTab = function SvgMicrosoftTeamsRemoveTab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 430 434.21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 215,
    cy: 217.11,
    rx: 215,
    ry: 217.11,
    style: {
      fill: "#f6f6fb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.37,
    y: 301.14,
    width: 15.42,
    height: 29.51,
    rx: 4.79,
    transform: "translate(310.2 39.3) rotate(63.34)",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.13,280.8h58.11a0,0,0,0,1,0,0V315a16.13,16.13,0,0,1-16.13,16.13H120.26A16.13,16.13,0,0,1,104.13,315V280.8a0,0,0,0,1,0,0Z",
    transform: "translate(311.88 16.77) rotate(63.34)",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,259.17H215.23a0,0,0,0,1,0,0V306a16.13,16.13,0,0,1-16.13,16.13H128.28A16.13,16.13,0,0,1,112.15,306V259.17A0,0,0,0,1,112.15,259.17Z",
    transform: "translate(315.01 -18.94) rotate(63.34)",
    style: {
      fill: "#7b82ea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.47,
    y: 266.48,
    width: 117.24,
    height: 13.84,
    rx: 4.3,
    transform: "translate(318.54 -59.21) rotate(63.34)",
    style: {
      fill: "#6068ba"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 305.63,
    width: 44.26,
    height: 4.95,
    rx: 1.54,
    transform: "translate(311.64 21.38) rotate(63.34)",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.09,
    y: 309.23,
    width: 32.13,
    height: 4.95,
    rx: 1.54,
    transform: "translate(310.9 29.78) rotate(63.34)",
    style: {
      fill: "#515ba5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.92,
    y: 131.72,
    width: 11.2,
    height: 112.55,
    rx: 4.37,
    transform: "translate(234.29 508.2) rotate(-116.97)",
    style: {
      fill: "#1b57b4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.56,
    y: 182.09,
    width: 11.2,
    height: 112.55,
    rx: 4.37,
    transform: "translate(226.67 604.27) rotate(-116.97)",
    style: {
      fill: "#1b57b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.38,246.8l-34.31,17.46c-2.56,1.31-5.31,1.08-6.13-.51",
    transform: "translate(-35 -32.89)",
    style: {
      fill: "none",
      stroke: "#a7cbf9",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.68,196.31l-34.3,17.47c-2.57,1.3-5.32,1.08-6.13-.52",
    transform: "translate(-35 -32.89)",
    style: {
      fill: "none",
      stroke: "#a7cbf9",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.44,
    y: 155.32,
    width: 15.42,
    height: 29.51,
    rx: 4.79,
    transform: "translate(390.72 568.26) rotate(-116.97)",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,154.89h58.11a0,0,0,0,1,0,0v34.24A16.13,16.13,0,0,1,391,205.26H365.18A16.13,16.13,0,0,1,349,189.13V154.89a0,0,0,0,1,0,0Z",
    transform: "translate(354.12 565.84) rotate(-116.97)",
    style: {
      fill: "#2979ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.74,170.37H386.82a0,0,0,0,1,0,0v55a8,8,0,0,1-8,8h-87a8,8,0,0,1-8-8v-55a0,0,0,0,1,0,0Z",
    transform: "translate(328.11 -221.4) rotate(63.03)",
    style: {
      fill: "#a7cbf9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.97,
    y: 177.49,
    width: 117.24,
    height: 13.84,
    rx: 4.3,
    transform: "translate(331.3 -261.51) rotate(63.03)",
    style: {
      fill: "#1b57b4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.82,
    y: 175.47,
    width: 44.26,
    height: 4.95,
    rx: 1.54,
    transform: "translate(361.61 566.17) rotate(-116.97)",
    style: {
      fill: "#1b57b4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.04,
    y: 171.83,
    width: 32.13,
    height: 4.95,
    rx: 1.54,
    transform: "translate(375.26 567.25) rotate(-116.97)",
    style: {
      fill: "#1b57b4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.94,346.69c17.23-8.51,28.86-15.82,28.86-15.82a149.68,149.68,0,0,1,20.45-11.74",
    transform: "translate(-35 -32.89)",
    style: {
      fill: "none",
      stroke: "#6068ba",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.29,151a179.1,179.1,0,0,1-16.69,6.52s-14.32,3.93-20.81,10.43",
    transform: "translate(-35 -32.89)",
    style: {
      fill: "none",
      stroke: "#2979ff",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.33,
    y1: 163.66,
    x2: 109.05,
    y2: 145.86,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.21,
    y1: 140.56,
    x2: 141.47,
    y2: 112.67,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.74,
    y1: 122.56,
    x2: 182.67,
    y2: 88.32,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.72,
    y1: 119.44,
    x2: 230.68,
    y2: 83.51,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.17,
    y1: 260.69,
    x2: 332.44,
    y2: 278.49,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.28,
    y1: 283.79,
    x2: 300.03,
    y2: 311.68,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.75,
    y1: 301.78,
    x2: 258.83,
    y2: 336.02,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.77,
    y1: 304.91,
    x2: 210.82,
    y2: 340.84,
    style: {
      fill: "none",
      stroke: "#1b57b4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftTeamsRemoveTab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft-teams-remove-tab.964d25df.svg";
export { ForwardRef as ReactComponent };